declare namespace $ {

	type $mol_row__sub_bog_vmap_app_inspect_row_1 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['tools'] >
		,
		ReturnType< $mol_row['sub'] >
	>
	type $bog_vmap_app_inspect_value__tree_bog_vmap_app_inspect_row_2 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['value'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['tree'] >
	>
	type $bog_vmap_app_inspect_value__binds_bog_vmap_app_inspect_row_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['binds'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['binds'] >
	>
	type $bog_vmap_app_inspect_value__nodes_bog_vmap_app_inspect_row_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['nodes'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['nodes'] >
	>
	type $bog_vmap_app_inspect_value__note_bog_vmap_app_inspect_row_5 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['note'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['note'] >
	>
	type $bog_vmap_app_inspect_value__path_bog_vmap_app_inspect_row_6 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['path'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['path'] >
	>
	type $bog_vmap_app_inspect_value__share_able_bog_vmap_app_inspect_row_7 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['share_able'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['share_able'] >
	>
	type $bog_vmap_app_inspect_value__share_mark_bog_vmap_app_inspect_row_8 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['share_mark'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['share_mark'] >
	>
	type $bog_vmap_app_inspect_value__share_bog_vmap_app_inspect_row_9 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['share'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['share'] >
	>
	type $bog_vmap_app_inspect_value__share_unshare_bog_vmap_app_inspect_row_10 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['share_unshare'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['share_unshare'] >
	>
	type $bog_vmap_app_inspect_value__editable_bog_vmap_app_inspect_row_11 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['editable'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['editable'] >
	>
	type $mol_status__status_bog_vmap_app_inspect_row_12 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['frozen'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $mol_check__title_bog_vmap_app_inspect_row_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__hint_bog_vmap_app_inspect_row_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['hint'] >
	>
	type $mol_check__checked_bog_vmap_app_inspect_row_15 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['keyed'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__enabled_bog_vmap_app_inspect_row_16 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['editable'] >
		,
		ReturnType< $mol_check['enabled'] >
	>
	type $mol_check__title_bog_vmap_app_inspect_row_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__hint_bog_vmap_app_inspect_row_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['hint'] >
	>
	type $mol_check__checked_bog_vmap_app_inspect_row_19 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['changeable'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__enabled_bog_vmap_app_inspect_row_20 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['editable'] >
		,
		ReturnType< $mol_check['enabled'] >
	>
	type $mol_button_minor__title_bog_vmap_app_inspect_row_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_inspect_row_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_vmap_app_inspect_row_23 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['share_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__enabled_bog_vmap_app_inspect_row_24 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['editable'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__title_bog_vmap_app_inspect_row_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_inspect_row_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_vmap_app_inspect_row_27 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['unshare_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__enabled_bog_vmap_app_inspect_row_28 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['editable'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_view__sub_bog_vmap_app_inspect_row_29 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['mark_sub'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_bog_vmap_app_inspect_row_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_inspect_row_31 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['drop_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_vmap_app_inspect_row_32 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['drop'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__enabled_bog_vmap_app_inspect_row_33 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_row['editable'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	export class $bog_vmap_app_inspect_row extends $mol_form_field {
		tools( ): readonly($mol_view)[]
		Tools( ): $mol_row
		path( ): string
		Value( ): $bog_vmap_app_inspect_value
		share_click( next?: any ): any
		unshare_click( next?: any ): any
		mark_sub( ): readonly($mol_view_content)[]
		sign( ): string
		owner( ): string
		inherited( ): boolean
		value( next?: $mol_tree2_empty ): $mol_tree2_empty
		binds( ): readonly(string)[]
		nodes( ): Record<string, any>
		keyed( next?: boolean ): boolean
		changeable( next?: boolean ): boolean
		drop( next?: any ): any
		editable( ): boolean
		frozen( ): string
		note( ): string
		share_able( id: any): boolean
		share_mark( id: any): string
		share( id: any, next?: any ): any
		share_unshare( id: any, next?: any ): any
		name( ): ReturnType< $bog_vmap_app_inspect_row['sign'] >
		bid( ): ReturnType< $bog_vmap_app_inspect_row['owner'] >
		label( ): readonly(any)[]
		control( ): ReturnType< $bog_vmap_app_inspect_row['Value'] >
		Frozen( ): $mol_status
		Key( ): $mol_check
		Next( ): $mol_check
		Share( ): $mol_button_minor
		Unshare( ): $mol_button_minor
		Mark( ): $mol_view
		drop_hint( ): string
		Drop( ): $mol_button_minor
	}
	
}

//# sourceMappingURL=row.view.tree.d.ts.map